export const buildVersion = {
  version: '1.4',
  buildNumber: 30,
  commit: '3bb37e783',
};
